const administratorOnlyIntegrationSlugs = new Set([
    'criteo',
    'tiktok',
    'google-merchant',
    'google-analytics',
    'google-search-console',
    'google-bigquery',
]);

export function isAdministratorOnlyBrand(brand) {
    return administratorOnlyIntegrationSlugs.has(brand?.slug);
}

export function isBrandVisibleToUser(brand, isAdministrator) {
    return !isAdministratorOnlyBrand(brand) || isAdministrator === true;
}
